import { api_GET, api_POST, api_PUT } from "./_api.js";

const tipoCompensacao_api = {
    getList: (status) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TiposCompensacao/getlist/${status ? status : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TiposCompensacao/getitem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (tipoCompensacao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`TiposCompensacao`, tipoCompensacao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (tipoCompensacao) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`TiposCompensacao`, tipoCompensacao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default tipoCompensacao_api;
